module.exports = __webpack_public_path__ + "static/6G-XR-480x480-7a955f9df1bca025c89e98add5aedce7.png";